
bq.singleAjax = function () {
    this.responses = {};
    this.callbacks = {};
};

bq.singleAjax.prototype = {
    _pushCallback: function (key, callback) {
        if (typeof this.callbacks[key] === 'undefined') {
            this.callbacks[key] = [];
        }
        this.callbacks[key].push(callback);
        return this;
    },
    _hasCallbacks: function (key) {
        return typeof (this.callbacks[key]) !== 'undefined' && this.callbacks[key].length;
    },
    _shiftCallback: function (key) {
        var result;
        if (typeof (this.callbacks[key]) !== 'undefined') {
            result = this.callbacks[key].shift();
        }
        return result;
    },
    _runCallbacks: function (key, args) {
        var callback;
        do {
            callback = this._shiftCallback(key);
            if (typeof (callback) === 'function') {
                callback.apply(undefined, args);
            }
        } while (this._hasCallbacks(key));
        return this;
    },
    _getResponse: function (key, url, data, complete) {
        var self = this;
        if (typeof this.responses[key] === 'undefined') {
            this.responses[key] = false;
            $.sjax(url, {
                'type': 'POST',
                'data': data,
                'complete': function (jqXHR, textStatus) {
                    self.responses[key] = [jqXHR.responseText, textStatus, jqXHR];
                    complete.apply(undefined, self.responses[key]);
                }
            });
        } else if (this.responses[key] !== false) {
            complete.apply(undefined, this.responses[key]);
        } else {
            /* Do nothing, other ajax request is in progress */
        }
        return this;
    },
    call: function (url, data, complete) {
        var key = btoa(url + ':' + JSON.stringify(data));
        this._pushCallback(key, complete);
        this._getResponse(key, url, data, function () {
            this._runCallbacks(key, arguments);
        }.bind(this));
    }
};

var singleAjax = new bq.singleAjax();
$.fn.extend({
    loadSingle: function (url, data, complete) {
        var self = this;
        singleAjax.call(url, data, function (responseText) {
            self.html(responseText);
            if (typeof complete === 'function') {
                complete.apply(undefined, arguments);
            }
        });
    }
});